export default __webpack_public_path__ + "static/media/stand-icon.0aece404.svg";